import React from 'react'
import { intl, isBOTIM } from 'utils'
import { BOTIM_MONEY_LOGO_WHITE } from 'utils/botimBrand'
import classes from './styles.module.scss'
// import { FormattedMessage } from 'react-intl'
import messages from './messages'
import { Flex } from 'antd-mobile'

const poweredByLogo = require('./images/payby-logo.svg')
const poweredByImage = require('./images/powered-by-botim-business.png')
const securityLogos = require('./images/security-logos-jaywan.png')

export default class TermsAndPrivacy extends React.Component {
  // constructor (props) {
  //   super(props)
  //   this.state = {
  //     foo: 'foo'
  //   }
  // }
  render() {
    const { onlyPoweredBy, hideCopyright } = this.props
    return (
      <div className={classes.payPageComponentsTermsAndPrivacy}>
        {!onlyPoweredBy && (
          <div className={classes.linkRow}>
            <a target='_blank' rel='noopener noreferrer' href='https://astratech.ae/platform-terms/botim-money-merchant-service-standard-terms-and-conditions/'>
              {intl().formatMessage(messages.Term)}
            </a>
            <a target='_blank' rel='noopener noreferrer' href='https://astratech.ae/platform-terms/privacy-policy/'>
              {intl().formatMessage(messages.Privacy)}
            </a>
          </div>
        )}
        {hideCopyright !== true &&
          <div className={classes.poweredByRow}>
            <img src={poweredByImage} alt='' />
          </div>}
        <div className={classes.securityRow}>
          <img src={securityLogos} alt='' />
        </div>
      </div>
    )
  }
}

export function Terms() {
  return (
    <a target='_blank' rel='noopener noreferrer' href='https://astratech.ae/platform-terms/botim-money-merchant-service-standard-terms-and-conditions/'>
      {intl().formatMessage(messages.Term)}
    </a>
  )
}

export function Privacy() {
  return (
    <a target='_blank' rel='noopener noreferrer' href='https://astratech.ae/platform-terms/privacy-policy/'>
      {intl().formatMessage(messages.Privacy)}
    </a>
  )
}

export function Pci() {
  return <img height={20} style={{ maxWidth: '100%', width: 'auto' }} src={securityLogos} alt='' />
}

export function PoweredBy() {
  return (
    <Flex align='center'>
      <span
        className='text_placeholder font-10'
        dangerouslySetInnerHTML={{
          __html: intl().formatHTMLMessage(messages.PoweredBy),
        }}
      />
      &nbsp;
      <img
        height={isBOTIM() ? 18 : 16}
        src={isBOTIM() ? BOTIM_MONEY_LOGO_WHITE : poweredByLogo}
        alt=''
      />
    </Flex>
  )
}
